/**
 * Global模块接口列表
 */
import { base, globalApiUrl } from './base' // 导入接口域名列表
import axios from '../utils/http'
const debug = process.env.NODE_ENV !== 'production'
const baseURL = debug ? base.development : base.production
axios.defaults.baseURL = baseURL

const global = {
  getCaptchaUrl () {
    return baseURL + globalApiUrl.CAPTCHA_URL + '?t=' + new Date().getTime()
  },
  getMsgCode (mobile = null, captcha = null, type = 'common') {
    return axios.post(globalApiUrl.MSG_CODE_URL, {
      mobile: mobile,
      captcha: captcha,
      type: type
    })
  },
  needCaptcha () {
    return axios.get(globalApiUrl.NEED_CAPTCHA_URL)
  }
}

export default global
